import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardComponent } from './card.component';

/**
 * The `CardModule` class represents a module for displaying cards in the application.
 * It provides functionality for creating and displaying cards with various content.
 */
@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule],
  exports: [CardComponent],
})
export class CardModule {}
